module.exports = __webpack_public_path__ + "static/media/marker-off-neutre.2eb908d1.svg";